'use client';

import { cn } from '@ahm/common-helpers';
import type { PropsWithChildren } from 'react';

interface DesktopLayoutProps extends PropsWithChildren {
  sidebar?: React.ReactNode;
  className?: string;
}

/**
 * Desktop Layout - 2 Column Grid Layout
 * Left: Main content (responsive width)
 * Right: Sticky sidebar (Amori AI, recommendations, etc.)
 */
export default function DesktopLayout({
  children,
  sidebar,
  className,
}: DesktopLayoutProps) {
  return (
    <div className={cn('w-full', className)}>
      {/* Mobile: Single column */}
      <div className="md:hidden">{children}</div>

      {/* Desktop: 2 columns */}
      <div className="hidden md:grid md:grid-cols-[1fr_380px] xl:grid-cols-[1fr_420px] gap-8 max-w-screen-2xl mx-auto p-6 md:px-12">
        {/* Main Content */}
        <main className="min-w-0 w-full">{children}</main>

        {/* Sidebar */}
        {sidebar && (
          <aside className="sticky top-24 h-[calc(100vh-120px)] overflow-hidden">
            {sidebar}
          </aside>
        )}
      </div>
    </div>
  );
}
